import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { api, type Broker, type CrossPlan } from "../lib/api.js";
import { AuthGate } from "../components/AuthGate.js";
import { ErrorText, marginTypeLabel, statusLabel, yen } from "../components/ui.js";

export function CrossPage() {
  return (
    <AuthGate>
      <CrossInner />
    </AuthGate>
  );
}

function CrossInner() {
  const [plans, setPlans] = useState<CrossPlan[]>([]);
  const [brokers, setBrokers] = useState<Broker[]>([]);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    api.crossPlans().then((r) => setPlans(r.plans)).catch(setError);
    api.brokers().then((r) => setBrokers(r.brokers)).catch(setError);
  }, []);

  const groups = useMemo(() => {
    const m = new Map<string, CrossPlan[]>();
    for (const p of plans) m.set(p.lastTradingDay, [...(m.get(p.lastTradingDay) ?? []), p]);
    return [...m.entries()].sort(([a], [b]) => b.localeCompare(a));
  }, [plans]);

  const brokerName = (id: string | null) => brokers.find((b) => b.id === id)?.name ?? "-";

  return (
    <section>
      <div className="row between">
        <h1>クロス</h1>
        <Link className="btn primary" to="/cross/new">
          予定を追加
        </Link>
      </div>
      <ErrorText error={error} />
      {groups.map(([day, list]) => {
        const total = list.reduce((s, p) => s + p.estTotal, 0);
        const cash = list.reduce((s, p) => s + p.priceAtPlan * p.shares, 0);
        return (
          <div className="card" key={day}>
            <div className="row between">
              <h2>権利付最終日 {day}</h2>
              <span className="muted">{list.length}件</span>
            </div>
            <p className="muted">
              予想コスト合計 {yen(total)} / 必要資金 {yen(cash)}
            </p>
            <ul className="list">
              {list.map((p) => (
                <li key={p.id}>
                  <Link to={`/cross/${p.id}`} className="row between">
                    <span>
                      <span className={`badge ${p.status}`}>{statusLabel[p.status]}</span> {p.stockCode} {p.stockName ?? ""} / {p.shares.toLocaleString("ja-JP")}株 /{" "}
                      {brokerName(p.brokerSettingId)} / {marginTypeLabel[p.marginType]}
                      {p.needsCloseReminder && <strong className="warn"> 現渡し未記録</strong>}
                    </span>
                    <span>{yen(p.estTotal)}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
      {plans.length === 0 && <p className="muted">まだクロス予定がありません。</p>}
    </section>
  );
}
